import { Heading, Icon, Span, type UiIconNames } from "@icg360/design-system";

import styles from "./key-deductibles.module.scss";

export const KeyDeductibles = ({ deductibles, labelledCoverages }) => {
  const valueDisplay = (value: string) => {
    const isApplicable = value !== "N/A" && value !== "";
    return isApplicable ? value : "N/A";
  };

  const coverageKeyMap: Record<
    string,
    { icon: UiIconNames; label: string; details: string }
  > = {
    allOtherPerils: {
      icon: "LossHistory",
      label: "All other perils",
      details:
        "The amount you pay before coverage begins, separate from a hurricane, windstorm, or hail deductible.",
    },
    windHail: {
      icon: "StormCloud",
      label: "Wind/Hail",
      details:
        "The amount you pay for damage from wind or hail before your coverage kicks in.",
    },
    hurricane: {
      icon: "Hurricane",
      label: "Hurricane",
      details:
        "Coverage for your belongings that aren't attached to your home, like furniture and clothing.",
    },
  };

  return deductibles?.map((deductible) => (
    <div className={styles.deductibleItemHeader} key={deductible.name}>
      <div className={styles.deductibleIcon}>
        <Icon name={coverageKeyMap[deductible.key].icon} size="lg" />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <Heading size="xs">{coverageKeyMap[deductible.key].label}</Heading>
          <Span color="quiet">{coverageKeyMap[deductible.key].details}</Span>
        </div>
        <div className={styles.valueDS}>
          <Span bold>
            {valueDisplay(
              labelledCoverages && labelledCoverages[deductible.key],
            )}
          </Span>
        </div>
      </div>
    </div>
  ));
};
